export default __webpack_public_path__ + "static/media/saro.247af878.jpeg";